import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import Chart from '@aytm/app/stats/page/question-views/vk/components/chart/Chart'

// The histogram's vk-family chart: derives the chartModel from answer.hist/curve[period] and
// renders the shared vk Chart (D3) inside its loading placeholder. Extracted from histogram/Block.jsx
// so the headless export (histogram/exportable.ts) can mount the chart without the Block's dropdown.
const HistogramChart = ({ id, period, answer, ticks, axis, palette, onExport, captureIndex = 0 }) => {
  const chartBars = answer?.hist?.[period]?.x?.map((x, i) => {
    return { x, y: answer?.['hist']?.[period]?.y?.[i] }
  })

  const chartModel = {
    x: answer?.['curve']?.[period]?.x || null,
    xTemplate: ticks?.x || null,
    maximized: 30,
    graph1: answer?.['curve']?.[period]?.y || null,
    graph2: null,
    xText: axis.x,
    yText: axis.y,
    xPrefix: '$',
    yPrefix: '',
    yLimit: 0,
    yTemplate: ticks?.y || null,
    backgroundColor: '#4c5a65',
    p: [],
    points: [],
    position: `${id}_info_view_chart`,
    print: false,
    panel: true,
    infographic: true,
    bars: chartBars,
    scale: 1,
    gridOpacity: 0.2
  }

  return (
    <Chart
      id={id}
      model={chartModel}
      palette={palette}
      infographic
      isWestendorp={false}
      onExport={onExport}
      captureIndex={captureIndex}
    />
  )
}

HistogramChart.displayName = 'HistogramChart'

HistogramChart.propTypes = {
  id: PropTypes.string,
  period: PropTypes.string,
  answer: answerPropType,
  ticks: PropTypes.shape({ x: PropTypes.string, y: PropTypes.string }),
  axis: PropTypes.shape({ x: PropTypes.string, y: PropTypes.string }),
  palette: PropTypes.arrayOf(PropTypes.string),
  isAnimated: PropTypes.bool,
  onExport: PropTypes.func,
  captureIndex: PropTypes.number
}

export default HistogramChart
